/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrolmentLiveSessionInputList } from '../../models/enrolment-live-session-input-list';
import { ImportResult } from '../../models/import-result';

export interface ApiEnrolmentSyncMasterclassPost$Params {
      body: EnrolmentLiveSessionInputList
}

export function apiEnrolmentSyncMasterclassPost(http: HttpClient, rootUrl: string, params: ApiEnrolmentSyncMasterclassPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
  const rb = new RequestBuilder(rootUrl, apiEnrolmentSyncMasterclassPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportResult>;
    })
  );
}

apiEnrolmentSyncMasterclassPost.PATH = '/api/enrolment/sync-masterclass';
